'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reduxForm = require('redux-form');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _constants = require('../../constants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');

var _phoneSmsVerification = require('../../redux/modules/phoneSmsVerification');
var _messageModal = require('../../redux/modules/messageModal');
var _userAuthentication = require('../../redux/modules/userAuthentication');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Redux
var changeValue = function changeValue(name, value) {return (0, _reduxForm.change)('editProfileForm', name, value);};var requiredFields = ['phone', 'reCaptcha'];

var formatRules = {
  default: {
    6: '-' },

  dash: {
    6: '-',
    8: ' ' } };



var normilize = function normilize() {var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return number.toString().replace(/\D/g, '');};

var getFormatRules = function getFormatRules(inputLength) {return inputLength > 10 ?
  formatRules.dash :
  formatRules.default;};


var formatNum = function formatNum(number) {
  if (!number) {
    return '';
  }

  var reverseRow = number.toString().replace(/\D/g, '').split('').reverse();
  var numberLen = reverseRow.length;
  var rules = getFormatRules(numberLen);

  return reverseRow.reduce(function (acc, num, idx) {
    var prefix = rules[idx] || '';

    return '' + prefix + num + acc;
  }, '');
};var

PhoneVerificationContainer = function (_Component) {_inherits(PhoneVerificationContainer, _Component);function PhoneVerificationContainer() {var _temp, _this, _ret;_classCallCheck(this, PhoneVerificationContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      countryCode: '',
      data: {},
      invalidFields: [],
      codeIsValid: true,
      codeIsVerified: false,
      phoneNumberIsInvalid: false,
      showCodePreloader: false,
      phoneNumberSent: false,
      errorMessage: '',
      showErrorMessage: false,
      doResetCaptcha: false,
      phoneNumberAlreadyTaken: false }, _this.













    componentWillReceiveProps = function (_ref)




    {var phoneNumber = _ref.userAuthenticationData.phone_number,smsVerify = _ref.phoneSmsVerification,locale = _ref.locale,translate = _ref.translate;
      if (!(0, _get2.default)(_this.props, 'userAuthenticationData.phone_number') && phoneNumber) {
        _this.savePhoneNumber(phoneNumber);
      }
      var stateModifier = {};

      if (smsVerify) {
        if (smsVerify.sendingPhoneNumber !== _this.props.phoneSmsVerification.sendingPhoneNumber) {
          stateModifier.showPhonePreloader = smsVerify.sendingPhoneNumber;
        }

        if (smsVerify.phoneNumberSent !== _this.props.phoneSmsVerification.phoneNumberSent) {
          stateModifier.phoneNumberSent = smsVerify.phoneNumberSent;
        }

        if (smsVerify.phoneError && !(0, _isEqual2.default)(smsVerify.phoneError, _this.props.phoneSmsVerification.phoneError)) {
          stateModifier.doResetCaptcha = true;
          // analytics
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.error, _analyticsConstants.eventAction.validation, smsVerify.phoneError.message);

          if (smsVerify.phoneError.status === _constants.requestErrorStatusCodes.BAD_REQUEST) {
            stateModifier.showErrorMessage = true;
            stateModifier.phoneNumberAlreadyTaken = true;
            if (smsVerify.phoneError.message === 'EXCEEDED_LIMIT_PER_MINUTE') {
              stateModifier.errorMessage = '' + _this.props.translate('phoneVerification', 'exceededLimitPerMinuteError');
            } else if (smsVerify.phoneError.message === 'EXCEEDED_LIMIT_PER_DAY') {
              stateModifier.errorMessage = '' + _this.props.translate('phoneVerification', 'exceededLimitPerDayError');
            } else {
              stateModifier.errorMessage = '' + _this.props.translate('phoneVerification', 'phoneWasVerifiedError');
            }
          } else {
            stateModifier.phoneNumberIsInvalid = true;
            _this.props.openMessageModal({ message:
              _react2.default.createElement('div', { className: 'contentMessage' },
                _react2.default.createElement('div', null,
                  _react2.default.createElement('p', null, _this.props.translate('phoneVerification', 'smsWasNotSentError')),
                  _react2.default.createElement('button', { className: 'btn btn-primary', onClick: _this.props.hideMessageModal }, _this.props.translate('phoneVerification', 'tryAgain')))) });



          }
        } else if (smsVerify.phoneError === null && smsVerify.phoneError !== _this.props.phoneSmsVerification.phoneError) {
          stateModifier.phoneNumberIsInvalid = false;
          stateModifier.showErrorMessage = false;
          stateModifier.doResetCaptcha = false;
        }

        // Update error message after locale change
        if (
        smsVerify.phoneError &&
        smsVerify.phoneError.status === _constants.requestErrorStatusCodes.BAD_REQUEST &&
        locale !== _this.props.locale)
        {
          stateModifier.errorMessage = translate('phoneVerification', 'phoneWasVerifiedError').toString();
        }

        if (smsVerify.codeIsValid !== _this.props.phoneSmsVerification.codeIsValid) {
          stateModifier.codeIsVerified = smsVerify.codeIsValid;
          _this.props.verificationSuccess(smsVerify.codeIsValid);
          _this.props.editUserProfile({
            userData: { phone_number: '' + _this.state.countryCode + _this.state.data.phone },
            userToken: _this.props.userAuthenticationData.access_token });

        }

        if (smsVerify.codeError && !(0, _isEqual2.default)(smsVerify.codeError, _this.props.phoneSmsVerification.codeError)) {
          stateModifier.codeIsValid = false;
          stateModifier.codeIsVerified = false;
        }

        if (smsVerify.sendingVerificationCode !== _this.props.phoneSmsVerification.sendingVerificationCode) {
          stateModifier.showCodePreloader = smsVerify.sendingVerificationCode;
        }
      }

      if (Object.keys(stateModifier).length) {
        _this.setState(stateModifier);
      }
    }, _this.

    savePhoneNumber = function (phoneNumber) {
      _this.initialPhoneNumber = phoneNumber;

      if (_this.props.isMyAccount && _this.initialPhoneNumber) {
        _this.saveData('phone', _this.initialPhoneNumber);
      }
    }, _this.

    validateForm = function (evt) {
      if (evt) {
        evt.preventDefault();
      }

      var invalidFields = requiredFields.filter(function (item) {
        switch (item) {
          case 'phone':{
              return !_this.validatePhoneNumber(_this.state.data.phone);
            }
          default:{
              return !_this.state.data[item];
            }}

      });

      var phoneNumberIsInvalid = invalidFields.includes('phone');
      var errorMessage = phoneNumberIsInvalid ?
      _this.props.translate('phoneVerification', 'phoneErrorMessage').toString() : '';

      _this.setState({
        invalidFields: invalidFields,
        errorMessage: errorMessage,
        phoneNumberIsInvalid: phoneNumberIsInvalid,
        showErrorMessage: !!invalidFields.length });


      if (!invalidFields.length) {
        _this.submitForm();
      }
      return true;
    }, _this.

    validatePhoneNumber = function (phoneNumber) {
      var number = normilize(phoneNumber);
      var isValid = number && number.length >= 9 && number.length <= 12;

      _this.setState({ phoneNumberIsInvalid: !isValid });
      return isValid;
    }, _this.

    verifyCode = function (code) {var _this$props$phoneSmsV =
      _this.props.phoneSmsVerification,verificationCodeSent = _this$props$phoneSmsV.verificationCodeSent,sendingVerificationCode = _this$props$phoneSmsV.sendingVerificationCode;
      if (_this.validateCode(code) && !verificationCodeSent && !sendingVerificationCode) {
        _this.setState({ codeIsValid: true });var
        accessToken = _this.props.userAuthenticationData.access_token;
        _this.props.verifyCode({ code: code, accessToken: accessToken });
      }
    }, _this.

    validateCode = function (code) {return code.length === 4;}, _this.

    submitForm = function () {var _this$state =
      _this.state,countryCode = _this$state.countryCode,_this$state$data = _this$state.data,reCaptcha = _this$state$data.reCaptcha,phone = _this$state$data.phone;var
      accessToken = _this.props.userAuthenticationData.access_token;
      var formatPhone = _this.props.isPublishForm ?
      (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(phone) :
      (0, _formatPhoneNumber.normalizePhoneAndCountryCode)(phone, countryCode);

      _this.props.sendPhoneNumber({
        captcha: reCaptcha,
        phone: formatPhone,
        locale: _this.props.locale,
        accessToken: accessToken });


      _this.setState({
        data: Object.assign({}, _this.state.data, { reCaptcha: null }),
        doResetCaptcha: true });

    }, _this.

    handlePhoneChange = function (evt) {var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';var flag = arguments[2];
      var normalizedValue = value.replace(/\s/g, '');

      _this.savePhoneNumber(normalizedValue);
      _this.saveData('phone', normalizedValue);

      if ('+' + flag.dialCode !== _this.state.countryCode) {
        _this.setState({ countryCode: '+' + flag.dialCode });
      }

      if (_this.props.isMyAccount) {
        _this.props.changeValue('phone_number', '+' + flag.dialCode + normalizedValue);
      }
    }, _this.

    handleChange = function (evt) {var _evt$target =
      evt.target,name = _evt$target.name,value = _evt$target.value;
      var normalizedValue = value.replace(/[\D]/g, '');

      if (name === 'phone') {
        evt.target.value = _this.props.isMobile ? normalizedValue : formatNum(normalizedValue);

        if (_this.props.isMyAccount) {
          _this.props.changeValue('phone_number', evt.target.value);
        }
      } else {
        evt.target.value = normalizedValue;
      }

      if (name === 'verificationCode') {
        _this.verifyCode(normalizedValue);
      }

      _this.saveData(name, normalizedValue);
    }, _this.

    fetchReCaptchaToken = function (token) {
      var stateModifier = {};

      if (token && _this.state.showErrorMessage) {
        stateModifier.showErrorMessage = false;
      }

      if (token) {
        stateModifier.reCaptcha = token;
      }

      _this.setState({ data: Object.assign({},
        _this.state.data,
        stateModifier) },
      _this.validateForm);
    }, _this.

    saveData = function (name, value) {var _Object$assign;return _this.setState({
        data: Object.assign({},
        _this.state.data, (_Object$assign = {}, _Object$assign[
        name] = value, _Object$assign)) });}, _temp), _possibleConstructorReturn(_this, _ret);}PhoneVerificationContainer.prototype.componentDidMount = function componentDidMount() {var phoneNumber = (0, _get2.default)(this.props, 'userAuthenticationData.phone_number');if (phoneNumber && phoneNumber.charAt(0) === '0') {phoneNumber.slice(1);}if (phoneNumber) {this.savePhoneNumber('' + (phoneNumber.length > 10 ? '+' : '') + phoneNumber);}};PhoneVerificationContainer.prototype.



  render = function render() {var
    sendingPhoneNumber = this.props.phoneSmsVerification.sendingPhoneNumber;
    var Form = this.props.isMyAccount ? _components.PhoneVerificationFormMyAccount : _components.PhoneVerificationForm;
    return (
      _react2.default.createElement('form', { onSubmit: this.validateForm },
        _react2.default.createElement(Form, {
          translate: this.props.translate('phoneVerification'),
          locale: this.props.locale,
          isMobile: this.props.isMobile,
          tooltipMsg: '' + this.props.translate('phoneVerification', 'phoneVerificationTootlipMessage'),
          validateCode: this.validateCode,
          validatePhoneNumber: this.validatePhoneNumber,
          phoneNumberIsInvalid: this.state.phoneNumberIsInvalid,
          sendPhoneNumber: this.validateForm,
          phoneNumberSent: this.state.phoneNumberSent,
          codeIsValid: this.state.codeIsValid,
          codeIsVerified: this.state.codeIsVerified
          // phoneNumberWasVerified={this.state.phoneNumberWasVerified}
          , showCodePreloader: this.state.showCodePreloader,
          showPhonePreloader: this.state.showPhonePreloader,
          fetchReCaptchaToken: this.fetchReCaptchaToken,
          onChange: this.handleChange,
          onPhoneChange: this.handlePhoneChange,
          errorMessage: this.state.errorMessage,
          showErrorMessage: this.state.showErrorMessage,
          doResetCaptcha: this.props.isPublishForm ? sendingPhoneNumber : this.state.doResetCaptcha,
          phoneNumberAlreadyTaken: this.state.phoneNumberAlreadyTaken,
          isRtl: this.props.isRtl,
          initialPhoneValue: this.initialPhoneNumber,
          phoneIsVerified: this.props.phoneIsVerified })));



  };return PhoneVerificationContainer;}(_react.Component);


PhoneVerificationContainer.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func.isRequired,
  userAuthenticationData: _propTypes2.default.object,
  phoneSmsVerification: _propTypes2.default.object,
  sendPhoneNumber: _propTypes2.default.func,
  verifyCode: _propTypes2.default.func,
  verificationSuccess: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  phoneIsVerified: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func,
  isMyAccount: _propTypes2.default.bool,
  isPublishForm: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref2) {var
  lang = _ref2.lang,
  windowDimentions = _ref2.windowDimentions,
  userAuthentication = _ref2.userAuthentication,
  phoneSmsVerification = _ref2.phoneSmsVerification;return (
    {
      locale: lang.locale,
      isRtl: (0, _checkRtlLanguage2.default)(lang.locale),
      translate: (0, _reduxPagan.getLang)(lang, 'static'),
      isMobile: windowDimentions.isMobile,
      phoneIsVerified: (0, _get2.default)(userAuthentication, 'data.verification.phone'),
      userAuthenticationData: userAuthentication.data || {},
      phoneSmsVerification: phoneSmsVerification });};


var mapDispatchToProps = {
  sendPhoneNumber: _phoneSmsVerification.sendPhoneNumber,
  verifyCode: _phoneSmsVerification.verifyCode,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  editUserProfile: _userAuthentication.editUserProfile,
  changeValue: changeValue };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
PhoneVerificationContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PhoneVerificationContainer/PhoneVerificationContainer.js
// module id = 3026
// module chunks = 0